import ReadOnlyRateCard from '../../../rate-card/read-only/read-only-rate-card';
import { useReturnDataContext } from '../../return-data-provider';

export function ShippingService() {
  const { requestDetails } = useReturnDataContext();

  const carrierId = requestDetails?.shippingInfo?.carrierId ?? '';
  const serviceName = requestDetails?.shippingInfo?.trackingDetails?.service ?? '';
  const trackingNumber = requestDetails?.shippingInfo?.trackingDetails?.trackingNumber ?? '';
  const carrierTrackingUrl = requestDetails?.shippingInfo?.trackingDetails?.carrierTrackingUrl ?? '';
  const shippingFee = requestDetails?.shippingInfo?.shippingCost?.amount ?? 0;
  const currency = requestDetails?.shippingInfo?.shippingCost?.currency ?? 'USD';

  return (
    <ReadOnlyRateCard
      carrierId={carrierId}
      serviceName={serviceName}
      totalCost={{ value: shippingFee, code: currency }}
      trackingNumber={trackingNumber}
      trackingUrl={carrierTrackingUrl}
    />
  );
}
